import styled from 'styled-components';
import { Card } from 'antd';

export const PageWrapper = styled(Card)`
  & {
    min-height: 70vh;
  }
`;
